import {
    Center,
    HStack, Text, VStack,
} from '@chakra-ui/react';
import { ComponentProps } from 'react';

function NonIdealState({
    iconComponent,
    title,
    description,
    titleFontSize = 'md',
    descriptionFontSize = 'md',
    ...props
}: {
    iconComponent: React.ReactNode;
    title: string;
    description?: string;
    titleFontSize?: ComponentProps<typeof Text>['fontSize'];
    descriptionFontSize?: ComponentProps<typeof Text>['fontSize'];
} & React.ComponentProps<typeof VStack>) {
    return (
        <HStack justifyContent="center" w="100%">
            <VStack {...props} gap={1} w="96">
                <Center w="200px" mb={5}>
                    {iconComponent}
                </Center>
                <Text fontWeight="bold" textAlign="center" fontSize={titleFontSize}>{title}</Text>
                <Text textAlign="center" fontSize={descriptionFontSize}>{description}</Text>
                <HStack py={2}>
                    {props.children}
                </HStack>
            </VStack>
        </HStack>
    );
}

export { NonIdealState };
